import React from 'react'
import { MainContainer, Content } from '../user/HomepageStarterEmail/styled'
import { useTranslation } from 'react-i18next'
import { useInfoTiers } from '../../hooks/useTier'
import { useCompleted } from '../../hooks/useLoading'
import { Loading } from '../shared/Loading'
import { Title } from '../user/HomepageStarterEmail/styled'
import { Col } from 'react-bootstrap'
import { envSetting } from '../../constants/envSetting'
import { SubTitle } from '../shared/simple/SubTitle'
import { Button } from '../shared/simple/Button'
import styled from 'styled-components'
import wisenrollLogo from '../../assets/images/login/wisenrolIcon.png'
import { Image } from 'react-bootstrap'
import { useHelp } from '../../hooks/useHelpMenu'

const ButtonContainer = styled.div`
  margin: 0 auto;
  width: 50%;
  min-width: 175px;
`

const StyledLogo = styled(Image)`
  height: 80px;
  margin-block: 20px;
  width: auto;
  max-width: 100%;
`;

const AltCompleted = () => {
  //? hook from Help
  const { goBack } = useHelp()
  //? hooks from Completed
  const { t } = useTranslation();
  const { nextTier } = useInfoTiers();
  const { loading } = useCompleted(nextTier);
  
  return (
    <MainContainer
    >
      {
        loading ? (
          <Loading />
        ) : 
        (
        <Content
          shouldHideProductSelection={true}
        >
          <Col className="p-5 pt-0 pb-3" xs={12}>
            <StyledLogo
             src={ envSetting.bgLogoWisenroll } 
            />
            <Title className="mt-2 mb-2">
              { t("common.congratulations") }
            </Title>
            <SubTitle className="mt-2 mb-2 p-2">
              { t("common.waitEmail") }
            </SubTitle>
          </Col>
          <ButtonContainer>
            <Button
              color='first'
              padding='8'
              onClick={goBack}
            >
              Go Back
            </Button>
          </ButtonContainer>
        </ Content>
        )
      }
    </MainContainer>
  )
}

export default AltCompleted